type DummyFactory<T> = (uuid: string, error?: any) => T

export default function cachedDummies<T>(factory: DummyFactory<T>): DummyFactory<T> {
  const cache = new Map<string, T>()
  return (uuid: string, error?: any) => {
    if (!error) {
      if (!cache.has(uuid)) {
        cache.set(uuid, factory(uuid))
      }
      return cache.get(uuid)!
    }
    return factory(uuid, error)
  }
}
